import { testimonials } from '../../../mocks/vehicles';

export default function TestimonialsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#1e3a8a]/10 rounded-full">
            <span className="text-[#1e3a8a] font-semibold text-sm flex items-center gap-2">
              <i className="ri-star-fill"></i>
              Avaliações Reais
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a8a]">
            O Que Nossos Clientes Dizem
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {testimonials.slice(0, 3).map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gradient-to-br from-[#1e3a8a]/5 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all"
            >
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>

              <div className="text-center mb-4">
                <i className="ri-double-quotes-l text-4xl text-[#c53030]/20"></i>
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed">
                {testimonial.text}
              </p>

              <div className="flex gap-1">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#c53030]"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 relative rounded-2xl overflow-hidden shadow-lg h-64">
            <img
              src="https://static.readdy.ai/image/5c0ad1e95b49fc3621673298b03cd410/673fcedb376bfa00466c0e604bbbffa0.jpeg"
              alt="Família feliz"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <h4 className="font-bold text-xl mb-1">{testimonials[3].name}</h4>
              <p className="text-sm text-white/80 mb-3">{testimonials[3].location}</p>
              <p className="text-white leading-relaxed">
                {testimonials[3].text}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="bg-gradient-to-br from-[#1e3a8a]/5 to-white rounded-2xl p-6 shadow-lg flex-1">
              <i className="ri-double-quotes-l text-3xl text-[#c53030]/20 mb-4 block"></i>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                {testimonials[4].text}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={testimonials[4].avatar}
                  alt={testimonials[4].name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h4 className="font-bold text-sm text-gray-900">{testimonials[4].name}</h4>
                  <p className="text-xs text-gray-600">{testimonials[4].location}</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#c53030]/5 to-white rounded-2xl p-6 shadow-lg flex-1 flex flex-col justify-center items-center text-center">
              <div className="text-5xl font-bold text-[#1e3a8a] mb-2">50+</div>
              <p className="text-gray-600 font-semibold">Famílias Satisfeitas</p>
              <div className="flex gap-1 mt-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#c53030]"></i>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
